import { Link } from "react-router-dom";
import { ROUTES } from "../routes/constants";
import "./404.scss";
export const PageNotFound = () => {
  return (
    <section className="page_404">
      <div className="container">
        <div className="row">
          <div>
            <div className="text-center">
              <div className="four_zero_four_bg">
                <h1 className="text-center">404</h1>
              </div>
              <div className="contant_box_404">
                <p>The page you are looking for was not found</p>
                <Link className="link_404" to={ROUTES.AUDIENCES}>
                  Go to Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageNotFound;
